import Section from "../common/Section.tsx";
import { useIntl } from "react-intl";
import DashboardAssetCard from "../common/DashboardAssetCard.tsx";
import BaseLinkOrButton from "../../../../common/core-ui/BaseLinkOrButton.tsx";
import clsx from "clsx";
import styles from "./RecentBooks.module.scss";
import { ManageAssetWithLicense } from "../../../../common/api/decimal/common-types/manageAssets.ts";

export default function RecentBooks({
  books,
  total,
}: {
  books: ManageAssetWithLicense[];
  total: number;
}) {
  const intl = useIntl();

  if (books.length === 0) {
    return null;
  }

  return (
    <Section
      title={intl.formatMessage({
        defaultMessage: "Recent Activity",
      })}
      headerButton={
        total >= 3 && (
          <BaseLinkOrButton
            className={clsx("vst-link", "vst-link-size-small", styles.viewAll)}
            to="/my-library"
            aria-label={intl.formatMessage({
              defaultMessage: "View all books in library",
            })}
          >
            {intl.formatMessage({ defaultMessage: "View All" })}
          </BaseLinkOrButton>
        )
      }
      gridClassName={styles.grid}
    >
      {books.slice(0, 2).map((asset: ManageAssetWithLicense, index: number) => {
        return (
          <DashboardAssetCard
            asset={asset}
            key={asset.manageAsset.vbid}
            onReturnComplete={() => {
              books.splice(index, 1);
            }}
          />
        );
      })}
    </Section>
  );
}
